import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const UkraineFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_16152'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_16152)'>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 7.46667H20V0H0V7.46667Z'
					fill='#156DD1'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M0 14H20V7.46667H0V14Z'
					fill='#FFD948'
				/>
			</g>
		</svg>
	);
};

export default UkraineFlagIcon;
